import { toActiveLayoutItem } from './active-layout-item.tsx';
import { transformActiveLayoutItems } from './active-layout-items.tsx';
import { transformBaseLayoutItems } from './base-layout-items.tsx';
import { transformCategory } from './category.tsx';
import { transformFieldOperations } from './field-operations.tsx';
import { transformField } from './field.tsx';
import { transformPanel } from './panel.tsx';
import { transformTabs } from './tabs.tsx';
import type { Transformers } from './types.tsx';

const transformers: Transformers = {
	activeLayoutItem: toActiveLayoutItem,
	field: transformField,
	fieldOperations: transformFieldOperations,
	panel: transformPanel,
	tabs: transformTabs,
	category: transformCategory,
	activeLayoutItems: transformActiveLayoutItems,
	baseLayoutItems: transformBaseLayoutItems,
};

export default transformers;
